import React, { Fragment } from 'react'
//import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
//import EventEmitter from 'react-native-md5'
import 'bootstrap/dist/css/bootstrap.min.css'
import _ from 'lodash'
import { Formik, Form, ErrorMessage } from 'formik'
import Select from 'react-select'

const divStyle = {
  float: 'left',
  paddingLeft: '0px',
}

const aStyle = {
  display: 'none',
}

class Table extends React.Component {
  constructor(props) {
    super(props)
    if (_.size(props.swap) > 0) {
      this.state = {
        swap: props.swap,
      }
    }
  }

  render() {
    const monthNames = [ 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December' ]
    const em = this.state.swap
    return <Formik initialValues={{ id: em.user.id, my_swap: 0, other_swap: 0 }} enableReinitialize={true} validate={values => {
          const errors = {}
          const selM = document.getElementById('mys')
          values.my_swap = selM.childNodes[1].value
          const selO = document.getElementById('others')
          values.other_swap = selO.childNodes[1].value
          if (!values.my_swap) {
            errors.my_swap = 'Required'
          } else if (!values.other_swap) {
            errors.other_swap = 'Required'
          }
          return errors
        }} onSubmit={(values, { setSubmitting }) => {
          const formData = new FormData()
          formData.append('is', em.user.id)
          formData.append('my_swap', values.my_swap)
          formData.append('other_swap', values.other_swap)
          //const urlf = '/api/v1/reminder/' + values.id
          const urlf = '#'
          const meth = 'POST'
          fetch(urlf, {
            method: meth,
            body: formData,
          })
          .then(response => response.json())
          .then(() => {
            document.getElementById('mylink').click()
          })
          .catch((err) => {
            console.error('Error while swapping on-calls! ' + err)
          })
          setTimeout(() => {
            setSubmitting(false)
          }, 400)
        }}>{({ isSubmitting}) => <Fragment><a href={'/teams/' + em.team.id} id="mylink" style={aStyle}></a><div className="col-sm-12"><div><a href="#" className="btn btn-secondary col-sm-1" onClick={() => this.handleToday(em)}>Today</a><a href="#" className="btn btn-secondary col-sm-1" onClick={() => this.handlePrev(em)} style={{marginLeft: '20px', display: this.state.swap.current === true ? 'none' : 'inline'}}>Previous</a><span className="col-sm-1 offset-sm-1"><b>{monthNames[em.month - 1]} {em.year} - {em.team.name}</b></span><a href="#" className="btn btn-secondary col-sm-1  offset-sm-1" onClick={() => this.handleNext(em)}>Next</a></div></div><br /><Form><div className="row col-sm-12"><div className="col-sm-6" style={divStyle}><div><label htmlFor="my_swap">Change my on-call:</label><br /><Select id="mys" name="my_swap" options={this.state.swap.myswaps}></Select></div><ErrorMessage name="my_swap" component="div"></ErrorMessage><br /></div><div className="col-sm-6" style={divStyle}><div><label htmlFor="other_swap">With:</label><br /><Select id="others" name="other_swap" options={this.state.swap.swapwith}></Select></div><ErrorMessage name="other_swap" component="div"></ErrorMessage><br /></div><button type="submit" disabled={isSubmitting}>Swap</button><br /><br /></div></Form></Fragment>}</Formik>
  }

  handlePrev(em) {
    let mth = em.month
    let year = em.year
    if (em.month === 1) {
      mth = 12
      year = em.year - 1
    } else {
      mth = em.month - 1
    }
    fetch('/api/v1/possible_swaps/' + em.team.id + '/' + em.user.id + '/' + mth + '/' + year, {
      method: 'GET',
      dataType: 'JSON',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
      },
    })
    .then((resp) => {
      return resp.json()
    })
    .then((data) => {
      this.setState({ swap: data })
    })
    .catch((error) => {
      console.error(error, 'catch the hoop')
    })
  }

  handleNext(em) {
    let mth = em.month
    let year = em.year
    if (em.month === 12) {
      mth = 1
      year = em.year + 1
    } else {
      mth = em.month + 1
    }
    fetch('/api/v1/possible_swaps/' + em.team.id + '/' + em.user.id + '/' + mth + '/' + year, {
      method: 'GET',
      dataType: 'JSON',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
      },
    })
    .then((resp) => {
      return resp.json()
    })
    .then((data) => {
      this.setState({ swap: data })
    })
    .catch((error) => {
      console.error(error, 'catch the hoop')
    })
  }

  handleToday(em) {
    const d = new Date()
    const mth = d.getMonth() + 1
    const year = d.getFullYear()
    fetch('/api/v1/possible_swaps/' + em.team.id + '/' + em.user.id + '/' + mth + '/' + year, {
      method: 'GET',
      dataType: 'JSON',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
      },
    })
    .then((resp) => {
      return resp.json()
    })
    .then((data) => {
      this.setState({ swap: data })
    })
    .catch((error) => {
      console.error(error, 'catch the hoop')
    })
  }
}

Table.propTypes = {
  swap: PropTypes.object,
}

export default Table
